import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CartService } from '../cart.service';
import { Subscription } from 'rxjs';
import { CartItem } from '../cart.model';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CustomCurrencyPipe } from '@shared/pipes/custom-currency.pipe';
import { ProfileService } from '../../profile/profile.service';

@Component({
  selector: 'app-investement-confirmed',
  imports: [
    CommonModule,
    CardModule,
    AngularSvgIconModule,
    ButtonModule,
    CustomCurrencyPipe,
  ],
  templateUrl: './investement-confirmed.component.html',
})
export class InvestementConfirmedComponent implements OnInit, OnDestroy {
  investedItems: CartItem[] = [];
  totalInvestedAmount: number = 0;
  currency: string | undefined;
  private investedItemsSub = Subscription.EMPTY;

  private readonly _cartService = inject(CartService);
  private readonly _router = inject(Router);
  private readonly _profileService = inject(ProfileService);

  ngOnInit(): void {
    this.currency = this._profileService.profile.currency;

    this.investedItemsSub = this._cartService.investedItems$.subscribe(
      (investedItems) => {
        if (investedItems.length === 0) {
          this._router.navigate(['home/properties']);
        }

        this.investedItems = investedItems;

        this.totalInvestedAmount = this.investedItems.reduce(
          (total, item) => total + item.amount,
          0
        );
      }
    );
  }

  onViewPortfolio(): void {
    this._router.navigate(['home/portfolio']);
  }

  ngOnDestroy(): void {
    this.investedItemsSub.unsubscribe();
    this._cartService.clearInvestedCart();
  }
}
